import {Alert, Breadcrumb, Button, Col, Row, Tabs} from "antd";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {ShareProductWidget} from "../../../../components/products/share-product-widget";
import {useEffect, useState} from "react";
import {SalesAndInsights} from "../../../../components/products/sales-and-insights";
import {ErrorBoundary} from "react-error-boundary";
import {EditProductBasicForm} from "../../../../products/useCases/edit-product/basic-form";
import {useGetProductContext} from "../../../../products/useCases/edit-product/context/get-product";
import {EditProductCheckoutForm} from "../../../../products/useCases/edit-product/checkout-form";
import {EditProductContentUpload} from "../../../../products/useCases/edit-product/content-upload";
import EditVariantsForm from "../../../../products/useCases/edit-product/edit-variants-form";
import {OfferingAutomations} from "../../../../components/offering-form/automations-step";

type TabKeys =
  | "form"
  | "automations"
  | "checkoutForm"
  | "content"
  | "variants"
  | "insights";
export function EditProductPage() {
  const {
    state: {productData, isFetchingProduct},
  } = useGetProductContext();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("form");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "checkoutForm") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "content") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "insights") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "variants") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "automations") {
        setDefaultActiveKey(activeTab);
      }
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "form") {
      setDefaultActiveKey("form");
      navigate(`${window.location.pathname}?activeTab=form`);
    }
    if (key === "automations") {
      setDefaultActiveKey("automations");
      navigate(`${window.location.pathname}?activeTab=automations`);
    }
    if (key === "checkoutForm") {
      setDefaultActiveKey("checkoutForm");
      navigate(`${window.location.pathname}?activeTab=checkoutForm`);
    }
    if (key === "content") {
      setDefaultActiveKey("content");
      navigate(`${window.location.pathname}?activeTab=content`);
    }
    if (key === "insights") {
      setDefaultActiveKey("insights");
      navigate(`${window.location.pathname}?activeTab=insights`);
    }

    if (key === "variants") {
      setDefaultActiveKey("variants");
      navigate(`${window.location.pathname}?activeTab=variants`);
    }
  }

  return (
    <DashboardWrapper pageTitle={`Edit Product`}>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/products">Products</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {productData.product.title.length > 20
            ? `${productData.product.title.substring(0, 20)}...`
            : productData.product.title}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div style={{marginTop: "1.5rem"}}>
        <Row gutter={[36, 30]}>
          <Col span={24} lg={{span: 16}}>
            <div>
              <Tabs
                defaultActiveKey={defaultActiveKey}
                activeKey={defaultActiveKey}
                onTabClick={(key) => handleTabClick(key)}
              >
                <Tabs.TabPane tab="Product info" key="form">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditProductBasicForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Automations" key="automations">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <OfferingAutomations contextOfferingId={productData.product.id} />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Checkout form" key="checkoutForm">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditProductCheckoutForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Content upload" key="content">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditProductContentUpload />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Add-ons" key="variants">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <EditVariantsForm />
                  </ErrorBoundary>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Sales and insights" key="insights">
                  <ErrorBoundary
                    FallbackComponent={({error, resetErrorBoundary}) => (
                      <>
                        <div style={{marginTop: "1.8rem"}}>
                          <Alert
                            message="Sorry, something went wrong."
                            showIcon
                            description={error.message}
                            type="error"
                            action={
                              <Button
                                onClick={() => {
                                  resetErrorBoundary();
                                }}
                                size="small"
                                danger
                              >
                                Reset
                              </Button>
                            }
                          />
                        </div>
                      </>
                    )}
                  >
                    <SalesAndInsights productData={productData} />
                  </ErrorBoundary>
                </Tabs.TabPane>
              </Tabs>
            </div>
          </Col>
          {productData.medias.length > 0 && (
            <Col span={24} lg={{span: 8}}>
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <>
                    <div style={{marginTop: "1.8rem"}}>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  </>
                )}
              >
                <ShareProductWidget
                  isFetching={isFetchingProduct}
                  productData={productData}
                />
              </ErrorBoundary>
            </Col>
          )}
        </Row>
      </div>
    </DashboardWrapper>
  );
}
